/**
 * the url prefix for the api gateway that attaches logged in users jwt to api requests
 *
 * We need two different api gateways because customer jwt cannot access
 * ref data endpoints
 */
export const SIMPLE_PAYMENTS_CUSTOMER_GW_PREFIX = "/api/gw/sp-customer";

/**
 * the url prefix for the api gateway that uses the service token to make api calls
 *
 * We need two different api gateways because customer jwt cannot access
 * ref data endpoints
 * @todo get ruby api changed so user access token has access to all api endpoints they should have access to
 *
 */
export const SIMPLE_PAYMENTS_SERVICE_GW_PREFIX = "/api/gw/sp-service";
